import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-[40vh] grid place-items-center text-sm text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && loc.pathname !== "/account") return <Navigate to="/account" replace />;
  if (role && user.role !== role && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
